"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterOption = void 0;
var _ColorOption = require("./optionTypes/ColorOption");
var _DefaultOption = require("./optionTypes/DefaultOption");
var _isColorOption = require("./utils/isColorOption");
var _jsxRuntime = require("react/jsx-runtime");
const FilterOption = (props)=>{
    const { label, selected, onClick, onDelete, LabelProps, OptionProps } = props;
    if ((0, _isColorOption.isColorOption)(props)) {
        const { hexColors } = props;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ColorOption.ColorOption, {
            label: label,
            hexColors: hexColors,
            selected: selected,
            LabelProps: LabelProps,
            OptionProps: OptionProps,
            onClick: onClick,
            onDelete: onDelete
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DefaultOption.DefaultOption, {
        label: label,
        selected: selected,
        LabelProps: LabelProps,
        OptionProps: OptionProps,
        onClick: onClick,
        onDelete: onDelete
    });
};
exports.FilterOption = FilterOption;
